function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FullParagraphComponent from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component";
import HighlightCard from "components/pages/whats-new/mobile/whats-new-mobile-second-fold/highlight-card/highlight-card-component";
import { blackTextFullParagraphConfig } from "../whats-new-first-fold-consts";
import { StyledWhatsNewFirstFoldComponent } from "./whats-new-first-fold-component.scss";
import classnames from "classnames";
const WhatsNewFirstFoldComponent = (props)=>{
    const { releaseHighlightsArray } = props;
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef();
    const settings = {
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        beforeChange: (oldIndex, newIndex)=>{
            setCurrentSlide(newIndex);
        },
        infinite: false,
        initialSlide: 0
    };
    const next = ()=>{
        currentSlide !== releaseHighlightsArray.length - 2 && sliderRef.current.slickNext();
    };
    const previous = ()=>{
        currentSlide !== 0 && sliderRef.current.slickPrev();
    };
    return /*#__PURE__*/ _jsxs(StyledWhatsNewFirstFoldComponent, {
        className: "whats-new-first-fold-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "left-space"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "left-section",
                children: [
                    /*#__PURE__*/ _jsx(FullParagraphComponent, _object_spread({}, blackTextFullParagraphConfig)),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "buttons-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: classnames("circle-with-arrow", {
                                    "first-slide": currentSlide === 0
                                }),
                                onClick: previous,
                                children: "<"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: classnames("circle-with-arrow", {
                                    "last-slide": currentSlide === releaseHighlightsArray.length - 2
                                }),
                                onClick: next,
                                children: ">"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ _jsxs(Slider, _object_spread_props(_object_spread({
                    ref: sliderRef
                }, settings), {
                    children: [
                        releaseHighlightsArray.map((highlight, index)=>/*#__PURE__*/ _jsx("div", {
                                className: "card",
                                children: /*#__PURE__*/ _jsx(HighlightCard, {
                                    imageUrl: highlight.cloudinaryUrl,
                                    title: highlight.title,
                                    description: highlight.shortText,
                                    articleLink: highlight.articleLink,
                                    isDesktop: true
                                })
                            }, index)),
                        /*#__PURE__*/ _jsx("div", {})
                    ]
                }))
            })
        ]
    });
};
export default WhatsNewFirstFoldComponent;
